// src/pages/LoginPage.jsx
import { useState } from 'react';
import { useAuth } from '../lib/AuthContext';
import logo from '../assets/logo.png';

export default function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await signIn(email, password);
    if (error) setError(error.message);
    setLoading(false);
  }

  return (
    <div className="login-page login-grid-bg">
      <div className="login-grid-overlay" />

      <div className="login-bg" />
      <div className="login-card">
        <div className="login-logo">
          <img src={logo} alt="Garnet Fund" className="login-logo-icon" />
          <div className="login-logo-name">
            <span className="g-red">GARNET</span> FUND
          </div>
          <div className="login-tagline">Portfolio Management Platform</div>
        </div>

        <div className="login-divider" />

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@garnetfund.com"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••••"
              required
            />
          </div>
          <button
            className="btn btn-primary"
            style={{ width: '100%', marginTop: 8, justifyContent: 'center', padding: '12px' }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: 22, textAlign: 'center', fontSize: 11, color: 'var(--text-lo)', fontFamily: 'var(--font-mono)', letterSpacing: '0.06em' }}>
          Contact your PM to request access
        </div>
      </div>

      <style>{`
        .login-page.login-grid-bg{ position:relative; overflow:hidden; }
        .login-grid-overlay{
          position:absolute; inset:0; pointer-events:none;
          background-image:
            linear-gradient(to right, rgba(255,255,255,0.055) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.055) 1px, transparent 1px);
          background-size: 40px 40px;
          opacity: 0.75;
          mask-image: radial-gradient(circle at 50% 30%, rgba(0,0,0,0.9), rgba(0,0,0,0.2) 55%, transparent 75%);
        }
      `}</style>
    </div>
  );
}
